var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25781 0.599609C1.15801 0.599609 0.257812 1.4998 0.257812 2.59961V15.3996C0.257812 16.4994 1.15801 17.3996 2.25781 17.3996H15.0578C16.1576 17.3996 17.0578 16.4994 17.0578 15.3996V2.59961C17.0578 1.4998 16.1576 0.599609 15.0578 0.599609H2.25781ZM2.25781 1.39961H15.0578C15.7252 1.39961 16.2578 1.93222 16.2578 2.59961V15.3996C16.2578 16.067 15.7252 16.5996 15.0578 16.5996H2.25781C1.59042 16.5996 1.05781 16.067 1.05781 15.3996V2.59961C1.05781 1.93222 1.59042 1.39961 2.25781 1.39961ZM5.45781 3.88633V14.1129L6.06641 13.741L13.825 8.99961L5.45781 3.88633ZM6.25781 5.31289L12.2906 8.99961L6.25781 12.6863V5.31289Z",
    fill: "#29CC8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.a78304b3f02f7cd6bee2e0122ef9f8cd.svg";
export { ForwardRef as ReactComponent };